module.exports = __webpack_public_path__ + "img/p.6cbbdfa8.jpg";